'use client';

import dynamic from 'next/dynamic';

const TowerViewer = dynamic(
  () => import('@/components/cad/TowerViewer'),
  {
    ssr: false,
    loading: () => (
      <div className="viewer-container">
        <div className="viewer-loading">
          <div className="viewer-spinner" />
          <p className="viewer-loading-text">Initializing 3D viewer...</p>
        </div>
      </div>
    ),
  }
);

export default function TowerSection() {
  return <TowerViewer />;
}
